'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';

export default function () {
  const pathname = usePathname();
  const locale = pathname.startsWith('/en-US') ? 'en-US' : 'zh-CN';

  return (
    <html
      style={{
        height: '100%',
        fontFamily: 'PingFang SC,HarmonyOS_Regular,Helvetica Neue,Microsoft YaHei,sans-serif',
      }}
    >
      <body style={{ height: '100%', background: 'white' }}>
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div style={{ marginBottom: 16, fontSize: '1.5rem', lineHeight: '2rem' }}>
            {locale === 'zh-CN' ? '当前页面不存在' : 'The current page does not exist'}
          </div>
          <Link
            href={`/${locale}`}
            style={{
              cursor: 'pointer',
              fontSize: '1.125rem',
              lineHeight: '2rem',
              color: '#3b82f6',
              textDecoration: 'none',
            }}
          >
            {locale === 'zh-CN' ? '返回首页' : 'Back to Home'}
          </Link>
        </div>
      </body>
    </html>
  );
}
